export const tpfrontup = "Szukasz wakacji All Inclusive?";
export const tpfrontdown = "Zobacz na Travelplanet.pl";
export const tplink = "https://www.travelplanet.pl/wakacje/all-inclusive/";
